module.exports = __webpack_public_path__ + "static/media/sf2.645c5408.jpg";